import { useCanvasStore } from "@/stores/canvas-store";
import type { AgentAnnotationTarget } from "./agent-annotation";

/** Retain the mark's identity as a tombstone until presentation cleanup. */
export function dismissAgentAnnotation(
  agentId: string,
  target: AgentAnnotationTarget,
): void {
  const matches = (candidate: AgentAnnotationTarget) =>
    target.annotationId
      ? candidate.annotationId === target.annotationId
      : !candidate.annotationId && candidate.seq === target.seq;
  const dismiss = (candidate: AgentAnnotationTarget) =>
    matches(candidate) ? { ...candidate, dismissed: true } : candidate;
  useCanvasStore.setState((state) => {
    const cursor = state.agentCursors.get(agentId);
    if (!cursor) return state;
    const agentCursors = new Map(state.agentCursors);
    agentCursors.set(agentId, {
      ...cursor,
      annotationTarget:
        cursor.annotationTarget && dismiss(cursor.annotationTarget),
      annotationTargets: cursor.annotationTargets?.map(dismiss),
    });
    return { agentCursors };
  });
}
